import cn from 'clsx'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const TextGroup = styled.div`
  display: flex;
  align-items: center;

  &.spacing-sm >:first-child {
    margin-right: ${rem(4)};
  }

  &.spacing-md >:first-child {
    margin-right: ${rem(8)};
  }

  &.spacing-lg >:first-child {
    margin-right: ${rem(12)};
  }

  &.spacing-xl >:first-child {
    margin-right: ${rem(16)};
  }
`
type IconDetailSpacing = 'md' | 'sm' | 'lg' | 'xl';

interface CaptionProps extends Omit<React.ComponentProps<typeof Caption>, 'variant'> {
  icon?: React.ReactNode;
  spacing?: IconDetailSpacing;
  variant: 'caption-medium' | 'caption-large';
  strong?: boolean;
}

interface BodyTextProps extends Omit<React.ComponentProps<typeof BodyText>, 'variant'> {
  icon?: React.ReactNode;
  spacing?: IconDetailSpacing
  variant?: 'body-medium' | 'body-large';
}

type Props = CaptionProps | BodyTextProps

function isCaption(props: Props): props is CaptionProps {
  return props.variant === 'caption-large' || props.variant === 'caption-medium'
}

/**
 * @deprecated Use one of the TextBlocks instead.
 */
function IconDetail(props: Props) {
  if (isCaption(props)) {
    const {
      children,
      spacing,
      icon,
      className,
      variant,
      ...captionProps
    } = props

    return <TextGroup
        {...captionProps}
        as={Caption}
        className={cn(className, `spacing-${spacing}`)}
        variant={variant === 'caption-large' ? 'large' : 'medium' }
      >
      {icon}
      {children}
    </TextGroup>
  } else {
    const {
      children,
      spacing,
      icon,
      className,
      variant,
      ...bodyProps
    } = props

    return <TextGroup
        {...bodyProps}
        as={BodyText}
        className={cn(className, `spacing-${spacing}`)}
        variant={variant === 'body-medium' ? 'medium' : 'large'}
      >
      {icon}
      {children}
    </TextGroup>
  }
}

IconDetail.defaultProps = {
  size: 'body-medium',
  spacing: 'md',
}

export default IconDetail
